import {useState, useEffect} from 'react';
import { useHydrationSafeState } from './useHydrationSafeState';

const useResponsive = () => {
  const [isClient, setIsClient] = useHydrationSafeState(false);
  const [isMobile, setIsMobile] = useHydrationSafeState(false);
  const [isDesktop, setIsDesktop] = useHydrationSafeState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Defer the client-side detection to avoid hydration mismatch
      const timer = setTimeout(() => {
        setIsClient(true);
        
        const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
        const desktopMediaQuery = window.matchMedia('(min-width: 1200px)');
        
        // Set initial values
        setIsMobile(mobileMediaQuery.matches);
        setIsDesktop(desktopMediaQuery.matches);
      
      // Event handlers
      const handleMobileChange = (e) => setIsMobile(e.matches);
      const handleDesktopChange = (e) => setIsDesktop(e.matches);
      
        // Add listeners
        mobileMediaQuery.addEventListener('change', handleMobileChange);
        desktopMediaQuery.addEventListener('change', handleDesktopChange);
        
        return () => {
          mobileMediaQuery.removeEventListener('change', handleMobileChange);
          desktopMediaQuery.removeEventListener('change', handleDesktopChange);
        };
      }, 0);
      
      return () => clearTimeout(timer);
    }
  }, [setIsClient, setIsMobile, setIsDesktop]);

  return {
    isMobile,
    isDesktop,
    isClient,
  };
};

export default useResponsive;
